module.exports = __webpack_public_path__ + "static/pinkhat-637caf31bb5bb275ba41376ed4b228f7.jpeg";